import React, { useEffect, useState } from "react";
import { InputPassword, InputText } from "../../components";
import { InputPhone } from "../../components/input/phoneNumber";
import { Button, CreateAlert, InputWraper, useForm } from "../../modules";
import { UserService } from "../../services";
import { UPDATE_MESSAGE_RESPONSE } from "../../services/user/constants";
import { validationSchema } from "./YupSchema";
const Profile = () => {
  const [profile, setProfile] = useState<any>(null);
  useEffect(() => {
    const getProfile = async () => {
      const pro = await UserService.getProfile();
      setProfile(pro?.result);
    };
    getProfile();
  }, []);
  const { handleSubmit, getInputProps, isSubmitting, setValues } = useForm({
    structure: validationSchema,
    onSubmit: async (values) => {
      const updateData = {
        fullName: values.fullName,
        username: values.username,
        email: values.email,
        phoneNumber: values.phoneNumber,
        currentPassword: values.currentPassword,
        newPassword: values.password,
      };
      return UserService.updateProfile(updateData)
        .then(async () => {
          CreateAlert({ type: "success", message: "Cập nhật thành công." });
          const pro = await UserService.getProfile();
          setProfile(pro?.result);
        })
        .catch((error) => {
          CreateAlert({
            message: UPDATE_MESSAGE_RESPONSE[error?.message] || error?.message,
            type: "danger",
          });
        });
    },
  });

  const handleCancel = () => {
    if (!profile) return;
    setValues({
      fullName: profile.fullName,
      username: profile.username,
      email: profile.email,
      phoneNumber: profile.phone.phoneNumber,
      currentPassword: "",
      password: "",
      confirmPassword: "",
    });
  };

  useEffect(() => {
    if (profile) {
      setValues({
        fullName: profile.fullName,
        username: profile.username,
        email: profile.email,
        phoneNumber: profile.phone.phoneNumber,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  return (
    <div className="profile-container">
      <div className="title">Thông tin chung</div>

      <div className="content">
        <form autoComplete="off" onSubmit={handleSubmit}>
          <div className="profile">
            <div className="profile__left">
              <InputWraper
                isRequired
                label={"Họ và tên"}
                inputProps={getInputProps("fullName")}
                component={InputText}
              />
              <InputWraper
                isRequired
                label={"Tên đăng nhâp"}
                inputProps={getInputProps("username")}
                component={InputText}
              />

              <InputWraper
                label={"Mật khẩu hiện tại"}
                inputProps={getInputProps("currentPassword")}
                component={InputPassword}
              />
              <InputWraper
                label={"Mật khẩu"}
                inputProps={getInputProps("password")}
                component={InputPassword}
              />
              <InputWraper
                label={"Xác nhận lại mật khẩu"}
                inputProps={getInputProps("confirmPassword")}
                component={InputPassword}
              />
            </div>
            <div className="profile__right">
              <InputWraper
                isRequired
                label={"Email"}
                inputProps={getInputProps("email")}
                component={InputText}
              />
              <InputWraper
                isRequired
                label={"Số điện thoại"}
                inputProps={getInputProps("phoneNumber")}
                component={InputPhone}
              />
            </div>
          </div>
        </form>

        <div className="btn-submit">
          <Button onClick={handleCancel} label="Hủy" isLoading={isSubmitting} />
          <Button
            buttonType="success"
            onClick={handleSubmit}
            label="Lưu"
            type="submit"
            isLoading={isSubmitting}
          />
        </div>
      </div>
    </div>
  );
};

export default Profile;
